export class TableRules {

  tableType: string = '';

  gearName: string = '';

  containsSpecies: string[] = [];

  excludesSpecies: string[] = [];

  releaseOnlySpecies: string[] = [];

  catchCategoryMappings: Map<string, string> = new Map();

  constructor(type: string = '', name: string = '') {
      this.gearName = name;
      this.tableType = type;
  }

  public isValid(): boolean {
      return !!this.gearName && this.containsSpecies.length > 0;
  }

}
